var _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconEmoji = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_emoji",
    transform: "translate(-274 -604)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9dafbd",
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    className: "cls-1",
    d: "M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-18a8 8 0 1 0 8 8 8.009 8.009 0 0 0-8-8z",
    transform: "translate(274 604)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9dafbd",
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    className: "cls-1",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(279 610)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9dafbd",
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    className: "cls-1",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(286 610)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "smile",
    d: "M288.341 616.329a5.185 5.185 0 0 1-4.421 2.471 5.185 5.185 0 0 1-4.42-2.471",
    fill: "none",
    stroke: "#9dafbd",
    strokeWidth: 1.5
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEmoji, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_emoji.6e22d347.svg";
export { ForwardRef as ReactComponent };